import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { UserAuth } from "../pages/auth/Auth";
import Loader from "../loader/Loader";

import TaskProperties from "../pages/setting/TaskProperties";
import MyTaskDone from "../pages/myTask/MyTaskDone";
import Login from "../pages/auth/Login";
import OfficeTiming from "../pages/setting/OfficeTiming";
import Department from "../pages/setting/Department";
import NotificationSetting from "../pages/setting/NotificationSetting";
import WhatsappSetting from "../pages/setting/WhatsappSetting";
import Holiday from "../pages/setting/Holiday";
import CompanyInfo from "../pages/setting/CompanyInfo";
import Users from "../pages/user/Users";
import DeletedUsers from "../pages/user/DeletedUsers";
import RaisedByMe from "../pages/helpTicket/RaisedByMe";
import RaisedToMe from "../pages/helpTicket/RaisedToMe";
import Role from "../pages/setting/role/Role";
import Permission from "../pages/setting/Permission";
import PermissionManagement from "../pages/setting/PermissionManagement";
import AuditorChecksheet from "../pages/auditor/AuditorChecksheet";
// import AuditorFlow from "../pages/auditor/AuditorFlow";
// import ChartReport from "../pages/chart/ChartReport";
import PermissionRoute from "./PermissionRoute";
import CompanyManagement from "../pages/setting/CompanyManagement";
import ReportsIndex from "../pages/Reports/ReportsIndex";
import PerformanceReport from "../pages/Reports/PerformanceReport";
import TaskReportIndex from "../pages/Reports/TaskReport/TaskReportIndex";
import ChecksheetReportIndex from "../pages/Reports/ChecksheetReport/ChecksheetReportIndex";
import FlowReportIndex from "../pages/Reports/FlowReport/FlowReportIndex";
import VerifyOtp from "../pages/auth/VerifyOtp";
import RePassword from "../pages/auth/RePassword";
import MyFMSDone from "../pages/myTask/MyFMSDone";
// import Schedule from "../pages/schedule/Schedule";
import SOPTask from "../pages/sopBank/SOPTask";
import SOPChecksheet from "../pages/sopBank/SOPChecksheet";
import SOPWorkFlow from "../pages/sopBank/SOPWorkFlow";
import YourSOP from "../pages/sopBank/YourSOP";
import FlowChartExample from "../pages/taskManager/workflow/FlowChart/FlowChart";
import MyFlowDiagram from "../pages/taskManager/workflow/FlowChart/MyFlowDiagram";
import UpgradeYourPlan from "../pages/CommonComponent/UpgradeYourPlan";
import ExpireSubscriptionModal from "../pages/CommonComponent/PlanExpireModal";

import BottleNeckReportTable from "../pages/Reports/BottleNeckReport/BottleNeckReportTableV2";
import BottleNeckReportV2 from "../pages/Reports/BottleNeckReport/BottleNeckReportV2";

import OrgChartIndex from "../pages/OrgChart/OrgChart";

import HodTask from "../pages/hodController/HodTask";
import HodCheckSheet from "../pages/hodController/HodCheckSheet";
// import ChatModuleindex from "../pages/ChatModule/ChatModuleindex";
import Attendance from "../pages/Attendance/Attendance";
import TaskDashboardIndex from "../pages/task/TaskDashboard/TaskDashboardIndex";
import ProjectIndex from "../pages/MiniProjects/ProjectIndex";
import ProjectDetailsIndex from "../pages/MiniProjects/ProjectDetails/ProjectDetailsIndex";
import { requestForToken } from './../utils/requestForToken';
import { PrivateAxios } from "../environment/AxiosInstance";
import { onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import PriorityBaseReport from "../pages/Reports/PriorityBaseReport/PriorityBaseReport";
import ProjectDetailsIndexdoer from "../pages/MiniProjects/ProjectDetails/ProjectTaskListDoer";
import ProjectDashboard from "../pages/Projects/ProjectDashboard/ProjectDashboard"
import AddTarget from "../pages/sales/AddTarget";
import ViewTargets from "../pages/sales/ViewTargets";
import UserPanel from "../pages/sales/UserPanel";
import SalesReport from "../pages/sales/SalesReport";
import HQOverview from "../pages/sales/HQOverview";
import TargetPI from "../pages/sales/TargetPI";
import AddPiTarget from "../pages/sales/AddPiTarget";
import WhatsappLogs from "../pages/whatsappLogs/WhatsappLogs";
const AssignByMe = React.lazy(() => import("../pages/taskManager/workflow/AssignByMe"));

const MyCheckSheetDOne = React.lazy(() => import("../pages/myTask/MyCheckSheetDOne"));
const Emailinfo = React.lazy(() => import("../pages/setting/Emailinfo"));
const SystemWorkFlow = React.lazy(() => import("../pages/systemController/SystemWorkFlow"));
const SystemWorkFlowGrid = React.lazy(() => import("../pages/taskManager/workflow/gridview/GridView"));
const AuditorTask = React.lazy(() => import("../pages/auditor/AuditorTask"));
const Master = React.lazy(() => import("../pages/Master"));
const WorkFlow = React.lazy(() => import("../pages/task/WorkFlow"));
const CheckSheet = React.lazy(() => import("../pages/task/CheckSheet"));
const TaskTracker = React.lazy(() => import("../pages/task/TaskTracker"));
const SystemCheckSheet = React.lazy(() => import("../pages/systemController/SystemCheckSheet"));
const Register = React.lazy(() => import('../pages/auth/Register'));
const ForgotPassword = React.lazy(() => import('../pages/auth/ForgotPassword'));
const ProtectedRoute = React.lazy(() => import("./ProtectedRoute"));
const Dashboard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
const EmployeesKpi = React.lazy(() => import("../pages/Reports/managementDashboard/EmployeesKpi"));
const BottleNeckReport = React.lazy(() => import("../pages/Reports/managementDashboard/BottleNeckReport"));
const TaskManagerWorkflow = React.lazy(() => import("../unKnown/TaskManagerWorkflow"));
const NewWorkflowTemplate = React.lazy(() => import("../unKnown/NewWorkflowTemplate"));
const NewWorkflowTask = React.lazy(() => import("../unKnown/NewWorkflowTask"));
const WorkFlowStepDetails = React.lazy(() => import("../unKnown/WorkFlowStepDetails"));
const FlowStepDetails = React.lazy(() => import("../pages/taskManager/workflow/FlowStepDetails"));
const AddNewChecksheet = React.lazy(() => import("../pages/taskManager/checksheet/AddNewChecksheet"));
const SystemTask = React.lazy(() => import('../pages/systemController/SystemTask'));
const SimpleWorkFlowTodo = React.lazy(() => import('../pages/SimpleWorkflow/MyFlowTask/SimpleWorkFlowTodo'));
const SimpleWorkFlowInProgress = React.lazy(() => import('../pages/SimpleWorkflow/MyFlowTask/SimpleWorkFlowInProgress'));
const SimpleWorkFlowCompleted = React.lazy(() => import('../pages/SimpleWorkflow/MyFlowTask/SimpleWorkFlowCompleted'));
const ListOfWorkFlow = React.lazy(() => import('../pages/SimpleWorkflow/ListOfWorkFlow/SimpleListOfWorkFlow'));
const CreateNewWorkflow = React.lazy(() => import('../pages/SimpleWorkflow/ListOfWorkFlow/CreateNewWorkflow'));
const BranchLocationList = React.lazy(() => import('../pages/BranchLocation/BranchLocationList'));

// const ProjectListIndex = React.lazy(() => import('../pages/Projects/ProjectList/ProjectListIndex.js'));

const MasterView = React.lazy(() => import("../pages/MasterView"));

// Order Workflow
const OrderWorkflowMaster = React.lazy(() => import("../pages/OrderWorkflow/MasterEntry/MasterEntry"));
const OrderWorkflowCreateProcess = React.lazy(() => import("../pages/OrderWorkflow/ProcessCreation/CreateProcess"));
const OrderWorkflowMyProcesses = React.lazy(() => import("../pages/OrderWorkflow/MyProcesses/MyProcesses"));
const OrderWorkflowMyTasks = React.lazy(() => import("../pages/OrderWorkflow/MyTasks/MyWorkflowTasks"));
const OrderWorkflowReports = React.lazy(() => import("../pages/OrderWorkflow/Reports/Reports"));
const OrderWorkflowGrid = React.lazy(() => import("../pages/taskManager/workflow/gridview/GridView"));
const ConnectProcessIndex = React.lazy(() => import("../pages/OrderWorkflow/ConnectProcess/ConnectProcessIndex"));
const OrderWorkflowReport = React.lazy(() => import("../pages/OrderWorkflow/Report/OrderWorkflowReport"));

// PMS
const PMSDashboard = React.lazy(() => import("../pages/PMS/PMSDashboard"));
const ProjectCreate = React.lazy(() => import("../pages/PMS/ProjectCreate"));
const ProjectDetails = React.lazy(() => import("../pages/PMS/ProjectDetails"));

const ProjectList = React.lazy(() => import("../pages/PMS/ProjectList"));
const TemplateManage = React.lazy(() => import("../pages/PMS/TemplateManage"));
const PMSMyTasks = React.lazy(() => import("../pages/PMS/PMSMyTasks"));





function PrivateRoutes() {

  const { isLoggedIn, MatchPermission, allPermissions, companyInfoGlobal, userDetails } = UserAuth();

  const [showPopup, setShowPopup] = useState(false);

  const [loginConform, setLoginConform] = useState(false);
  // const [diffDay, setDiffDay] = useState('')

  // useEffect(() => {
  //   if (companyInfoGlobal.project_start_date == 129) {
  //     setShowPopup(true);
  //     const interval = setInterval(() => {
  //       setShowPopup(true);
  //     }, 1800000);

  //     return () => clearInterval(interval);
  //   }
  // }, [companyInfoGlobal]);


  useEffect(() => {
    const currentDate = new Date();
    const renewDate = new Date(companyInfoGlobal.renew_date);

    // Calculate date 7 days before renew_date
    const sevenDaysBefore = new Date(renewDate);
    sevenDaysBefore.setDate(renewDate.getDate() - 7);

    if (currentDate >= sevenDaysBefore) {
      const lastShown = localStorage.getItem("last_popup_shown");

      if (!lastShown || currentDate.getTime() - parseInt(lastShown) >= 4 * 60 * 60 * 1000) {
        setShowPopup(true);
        localStorage.setItem("last_popup_shown", currentDate.getTime().toString());
      }

      const interval = setInterval(() => {
        const now = new Date().getTime();
        const last = parseInt(localStorage.getItem("last_popup_shown") || "0");

        if (now - last >= 4 * 60 * 60 * 1000) {
          setShowPopup(true);
          localStorage.setItem("last_popup_shown", now.toString());
        }
      }, 60 * 1000); // check every 1 minute (lightweight)

      return () => clearInterval(interval);
    }
  }, [companyInfoGlobal]);


  //   <h2>Your payment is due!</h2>
  // <h3>Kindly renew to continue using Growthh</h3>
  // [Button] Proceed to Renew [/Button]

  const htmlContent =
    <>
      <h5 class='mt-3 mb-2 fs-5'>
        Your payment is due!
      </h5>
      <h5 class='fs-6'>
        Kindly renew to continue using Growthh
      </h5>
    </>
    ;

  // const htmlContent1 =
  //   <>
  //     <h5 class='mt-3 mb-2 fs-5'>
  //       Dear <span class='fw-bold'>Threadbucket Studio</span>,
  //     </h5>
  //     <h5 class='fs-6'>
  //       Your system renewal will expire on <span class='fw-bold'>20<sup>th</sup> May 2025</span>.
  //       For a renewal please contact <a href="mailto:crm@growthh.com" class='fw-bold'>crm@growthh.com</a> or using the following link.
  //     </h5>
  //   </>
  //   ;


  const imageicon = `${process.env.PUBLIC_URL}/assets/images/notification.png`;

  useEffect(() => {
    if (userDetails?.id) {
      requestForToken(userDetails?.id);
    }
  }, [userDetails?.id]);

  useEffect(() => {
    onMessage(messaging, (payload) => {
      if (Notification.permission === 'granted') {
        new Notification(payload.data.title, {
          body: payload.data.body,
          icon: imageicon
        });
      }
    });
  }, [])


  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path="/" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Login setLoginConform={setLoginConform} />} />
        <Route path="/forget-password" element={isLoggedIn ? <Navigate to="/dashboard" /> : <ForgotPassword />} />
        <Route path="/register" element={isLoggedIn ? <Navigate to="/dashboard" /> : <Register />} />
        <Route path="/otp" element={isLoggedIn ? <Navigate to="/dashboard" /> : <VerifyOtp />} />
        <Route path="/update-password" element={isLoggedIn ? <Navigate to="/dashboard" /> : <RePassword />} />

        <Route element={<ProtectedRoute isLogin={isLoggedIn} />}>
          <Route path="/dashboard" element={<Dashboard />} />

          <Route path="/flow" element={<WorkFlow />} />
          <Route path="/employees-kpi" element={<EmployeesKpi />} />
          <Route path="/bottle-neck-report" element={<BottleNeckReport />} />
          {/* bottle neck report v2 */}
          <Route path="/bottle-neck-report-new" element={<BottleNeckReportTable />} />
          <Route path="/bottle-neck-chart-report" element={<BottleNeckReportV2 />} />
          {/* bottle neck report v2 */}

          <Route path="/my-task-done/:id" element={<MyTaskDone />} />
          <Route path="/:id" element={<MyTaskDone />} />
          <Route path="/my-checksheet-done/:id" element={<MyCheckSheetDOne />} />
          {/* <Route path="/workflow" element={<TaskManagerWorkflow />} /> */}
          <Route path="/new-workflow-template" element={<NewWorkflowTemplate />} />
          <Route path="/create-new-workflow-task" element={<NewWorkflowTask />} />
          <Route path="/flow-step-details" element={<FlowStepDetails />} />
          <Route path="/workflow-step-details" element={<WorkFlowStepDetails />} />

          {/* Task */}
          <Route path="/task" element={<TaskTracker />} />

          {/* checksheet */}
          <Route path="/checksheet" element={<CheckSheet />} />
          {/* chart */}
          {/* <Route path="/chart" element={<ChartReport />} /> */}

          {/* system controller */}
          <Route path="/system-task" element={<SystemTask />} />
          <Route path="/system-checksheet" element={<SystemCheckSheet />} />
          <Route path="/auditor" element={<AuditorTask />} />
          <Route path="/auditor-checksheet" element={<AuditorChecksheet />} />
          {/* <Route path="/auditor-flow" element={<AuditorFlow />} /> */}
          <Route path="/system-flow" element={<SystemWorkFlow />} />
          <Route path="/system-flow-creation" element={<AssignByMe />} />
          <Route path="/system-flow-grid" element={<SystemWorkFlowGrid />} />
          {/* Setting URL */}
          <Route path="/office-timing" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(['Edit Office Time'])}> <OfficeTiming /></PermissionRoute>} />
          <Route path="/department" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Add Department", "View Departments", "Edit Department", "Delete Department"])}><Department /></PermissionRoute>} />
          <Route path="/notification-setting" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(['General Notification'])}><NotificationSetting /></PermissionRoute>} />
          <Route path="/whatsapp-setting" element={<WhatsappSetting />} />
          <Route path="/email-setting" element={<Emailinfo />} />
          <Route path="/task-properties" element={<TaskProperties />} />
          <Route path="/holiday" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Add Holiday", "View Holiday", "Edit Holiday", "Delete Holiday",])}><Holiday /></PermissionRoute>} />
          <Route path="/role" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(['Role'])}><Role /></PermissionRoute>} />
          <Route path="/permission" element={<Permission />} />
          <Route path="/permission-management" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(['System Controller'])}><PermissionManagement /></PermissionRoute>} />
          <Route path="/company-info" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(['Company Info'])}><CompanyInfo /></PermissionRoute>} />
          <Route path="/company-management" element={<CompanyManagement />} />

          {/* Users Details */}
          <Route path="/users" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["View Users", "Edit User"])}><Users /></PermissionRoute>} />

          <Route path="/deleted-users" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Delete User"])}><DeletedUsers /></PermissionRoute>} />
          {/* Help Desk */}
          <Route path="/raised-by-me" element={<RaisedByMe />} />
          <Route path="/raised-to-me" element={<RaisedToMe />} />

          {/* Master */}
          <Route path="/master" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Master Table"])}><Master /></PermissionRoute>} />
          <Route path="/master-view" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Master Table"])}><MasterView /></PermissionRoute>} />

          {/* Reports */}
          <Route path="/reports" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Report"])}><ReportsIndex /></PermissionRoute>} />
          <Route path="/performance-report" element={<PerformanceReport />} />
          <Route path="/priority-base-report" element={<PriorityBaseReport />} />
          <Route path="/task-report" element={<TaskReportIndex />} />
          <Route path="/chesksheet-report" element={<ChecksheetReportIndex />} />

          {/* ===========Flow Dynamic report============== */}
          <Route path="/flow-report" element={<FlowReportIndex />} />
          {/* <Route path="/create-flow-report" element={<FlowReportIndex />} /> */}
          {/***************End Flow Dynamic report****************/}
          <Route path="/flow-done/:id" element={<MyFMSDone />} />
          {/* <Route path="/schedule" element={<Schedule />} /> */}
          <Route path="/sop-task" element={<SOPTask />} />
          <Route path="/sop-checksheet" element={<SOPChecksheet />} />
          <Route path="/sop-work-flow" element={<SOPWorkFlow />} />
          <Route path="/my-sop" element={<YourSOP />} />
          {/* Work flow Diagrams */}
          <Route path="/flow-charts" element={<FlowChartExample />} />
          <Route path="/flow-diagrams" element={<MyFlowDiagram />} />
          <Route path="/upgrade-plan" element={<UpgradeYourPlan />} />
          {/* Simple workflow */}
          <Route path="/simple-workflow" element={<SimpleWorkFlowTodo />} />
          <Route path="/simple-workflow/inprogress" element={<SimpleWorkFlowInProgress />} />
          <Route path="/simple-workflow/completed" element={<SimpleWorkFlowCompleted />} />
          <Route path="/simple-list-of-workflow" element={<ListOfWorkFlow />} />
          <Route path="/create-workflow" element={<CreateNewWorkflow />} />

          {/* Branch / location */}
          <Route path="/branch" element={<BranchLocationList />} />
          {/* Org chart */}
          <Route path="/org-chart" element={<OrgChartIndex />} />
          {/*================= HOD Controller =====================*/}

          <Route path="/hod-task" element={<HodTask />} />
          <Route path="/hod-checksheet" element={<HodCheckSheet />} />

          {/*================= Chat Module =====================*/}
          {/* <Route path="/chat" element={<ChatModuleindex />} /> */}
          {/*================= Attendance Module =====================*/}
          <Route path="/attendance" element={<Attendance />} />
          {/*================= Task Dashboard =====================*/}
          {/* <Route path="/task-dashboard" element={<TaskDashboardIndex />} /> */}
          {/*================= Mini Project =====================*/}
          <Route path="/projects" element={<PermissionRoute allPermission={allPermissions} name="Project Access"><ProjectIndex /></PermissionRoute>} />

          <Route path="/project-details/:id" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Add Project", "View Project", "Edit Project", "Delete Project", "Project All"])}><ProjectDetailsIndex /></PermissionRoute>} />
          <Route path="/project-details/doer" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Add Project", "View Project", "Edit Project", "Delete Project", "Project All"])}><ProjectDetailsIndexdoer /></PermissionRoute>} />
          <Route path="/projects/dashboard" element={<PermissionRoute allPermission={allPermissions} name={MatchPermission(["Add Project", "View Project", "Edit Project", "Delete Project", "Project All"])}><ProjectDashboard /></PermissionRoute>} />

          <Route path="/sales/add-target" element={<AddTarget />} />
          <Route path="/sales/targets" element={<ViewTargets />} />
          <Route path="/sales/user-panel" element={<UserPanel />} />
          <Route path="/sales/report" element={<SalesReport />} />
          <Route path="/sales/hq-overview" element={<HQOverview />} />
          <Route path="/sales/target-pi" element={<TargetPI />} />
          <Route path="/sales/add-pi-target" element={<AddPiTarget />} />
          <Route path="/whatsapp-logs" element={<WhatsappLogs />} />

          {/* Order Workflow Routes */}
          <Route path="/order-workflow/master" element={<OrderWorkflowMaster />} />
          <Route path="/order-workflow/create-process" element={<OrderWorkflowCreateProcess />} />
          <Route path="/order-workflow/create-process" element={<OrderWorkflowCreateProcess />} />
          <Route path="/order-workflow/all-process" element={<OrderWorkflowMyProcesses />} />
          <Route path="/order-workflow/my-tasks" element={<OrderWorkflowMyTasks />} />
          <Route path="/order-workflow/reports" element={<OrderWorkflowReports />} />
          <Route path="/order-workflow/connect-process" element={<ConnectProcessIndex />} />
          <Route path="/order-workflow/report" element={<OrderWorkflowReport />} />

          <Route path="/order-workflow/process-grid" element={<OrderWorkflowGrid />} />

          {/* PMS Routes */}
          <Route path="/pms/dashboard" element={<PMSDashboard />} />
          <Route path="/pms/projects" element={<ProjectList />} />
          <Route path="/pms/create-project" element={<ProjectCreate />} />
          <Route path="/pms/project/:id" element={<ProjectDetails />} />
          <Route path="/pms/templates" element={<TemplateManage />} />
          <Route path="/pms/my-tasks" element={<PMSMyTasks />} />




        </Route>
      </Routes>
      <ExpireSubscriptionModal show={showPopup} link={companyInfoGlobal.link} content={htmlContent} handleClose={() => { setShowPopup(false) }} />
      {/* <ExpireSubscriptionModal show={showPopup1} content={htmlContent1} handleClose={() => { setShowPopup1(false); }} /> */}
    </Suspense >
  );
}

export default PrivateRoutes;